<template>
  <el-dialog title="批量设置尺寸" :visible.sync="dialogVisible" width="700px"
    :close-on-click-modal="false" append-to-body>
    <div class="batch-form">
      <span class="batch-label">尺寸：</span>
      <div class="size-inputs">
        <el-input v-model.trim="form.length" placeholder="长" type="number" min="0" step="0.01">
          <template slot="append">cm</template>
        </el-input>
        <span class="size-separator">×</span>
        <el-input v-model.trim="form.width" placeholder="宽" type="number" min="0" step="0.01">
          <template slot="append">cm</template>
        </el-input>
        <span class="size-separator">×</span>
        <el-input v-model.trim="form.height" placeholder="高" type="number" min="0" step="0.01">
          <template slot="append">cm</template>
        </el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BatchSizeSetting',
  data() {
    return {
      dialogVisible: false,
      form: { length: '', width: '', height: '' }
    }
  },
  methods: {
    // 批量弹窗默认留空，确认后由父组件覆盖已勾选库位。
    open() {
      this.form = { length: '', width: '', height: '' }
      this.dialogVisible = true
    },
    confirm() {
      const fields = [
        { key: 'length', label: '长' },
        { key: 'width', label: '宽' },
        { key: 'height', label: '高' }
      ]
      const invalidField = fields.find(item => {
        const value = this.form[item.key]
        return value !== '' && !/^\d+(\.\d{1,2})?$/.test(String(value))
      })
      if (invalidField) {
        this.$message.error(`${invalidField.label}只能输入大于等于0的数字，最多两位小数`)
        return
      }
      this.$emit('confirm', { ...this.form })
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-form,
.size-inputs {
  display: flex;
  align-items: center;
}

.batch-form {
  min-height: 100px;
  padding: 16px 24px;
}

.batch-label {
  width: 70px;
  line-height: 40px;
  text-align: right;
  margin-right: 18px;
  flex: none;
}

.size-inputs {
  gap: 10px;

  .el-input {
    width: 140px;
  }
}

.size-separator {
  color: #606266;
  font-size: 18px;
  line-height: 40px;
}
</style>
